import { UploadTargetType } from './image-upload.services'
export const handleImageFile = async ({
  file,
  setSelectedFiles,
  id,
  onImageAction,
  actionName,
  target,
  payload,
  tempCropPosition,
  cropResult,
  croppedSize,
  updateImageIds,
  updateCoverImageId,
  updateOgImageId,
  articleState,
}) => {
  const updateSelectedFiles = (updated) => {
    return setSelectedFiles((prevArray) => {
      const idx = prevArray.findIndex((val) => val.id === file.id)
      const result = {
        ...prevArray[idx],
        ...updated,
        isCover: target === UploadTargetType.ARTICLE_IMAGES ? true : null,
      }
      if (!result.id) {
        const updatedId = idx !== -1 ? file.id : id
        result.id = updatedId
      }
      if (actionName === 'upload' && result.isCover && updated.id) {
        updateCoverImageId(updated.id)
      }
      return [result]
    })
    // }
  }

  const initial = {}
  initial[actionName] = {
    errorCodes: [],
    completedPercent: 5,
    success: null,
  }
  updateSelectedFiles(initial)

  const handleProgress = (progressEvent) => {
    const updating = {}
    updating[actionName] = initial[actionName]
    if (progressEvent.loaded * 100 !== progressEvent.total) {
      updating[actionName].completedPercent =
        Math.round((progressEvent.loaded * 100) / progressEvent.total) <= 10
          ? 5
          : Math.round((progressEvent.loaded * 100) / progressEvent.total) - 5
    }
    updateSelectedFiles(updating)
  }

  const response = await onImageAction({
    ...payload,
    config: { onUploadProgress: handleProgress },
  })

  const online = navigator.onLine
  let updated: Record<string, unknown> = {}
  if (online && response && response.status === 200) {
    const data = response.data
    if (data && data.id && data.originalUrl) {
      updated = {
        id: data.id,
        originalUrl: data.originalUrl,
        originalSize: data.originalSize,
        originalWidth: data.originalSize.width,
        originalHeight: data.originalSize.height,
        croppedUrl: data.croppedUrl,
        file,
      }
      if (tempCropPosition && cropResult && croppedSize) {
        updated.cropPosition = tempCropPosition
        updated.crop = cropResult.crop
        updated.croppedSize = croppedSize
      }
      updated[actionName] = {
        statusCode: response.status,
        success: true,
        completedPercent: 95,
        errorCodes: [],
      }
      if (actionName === 'upload') {
        if (target === UploadTargetType.OG_IMAGE) {
          /**
           * 目前只有在這裡 (也就是使用者自行變更 og 圖時) 會觸發 updateOgImageId，
           * 在封面圖跟 og 圖比例不一樣的情況下，
           * 如果 og 圖為預設的封面圖片第一張，則 gql 的 ogImage 為 null，
           * 內文用 images[0] 組 shaper url 取得 og 圖
           */
          updateOgImageId(data.id)
        } else if (target === UploadTargetType.ARTICLE_IMAGES) {
          updateImageIds([data.id])
        }
      }
      /**
       * Joy
       *   目前後端組 appPost 的時機是 autosave
       *   因此 edit （裁切）也需要 updateImageIds 觸發 autosave
       *   否則 appPost 不會有新的 croppedUrl
       */
      if (actionName === 'edit') {
        updateImageIds([data.id])
      }
    }
  } else {
    let errorCodes
    if (!online) {
      errorCodes = ['network']
    } else {
      errorCodes = response.errorCodes
    }
    updated[actionName] = {
      errorCodes,
      statusCode: response ? response.status : null,
      success: false,
    }
    updated.file = file
    if (tempCropPosition && cropResult && croppedSize) {
      updated.cropPosition = tempCropPosition
      updated.crop = cropResult.crop
      updated.croppedSize = croppedSize
    }
  }
  updateSelectedFiles(updated)
}
